var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclamationActiveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-542 -583)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 26",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(542 583)",
    style: {
      fill: "#d95342"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 61627",
    d: "M15.755 19.8a1.543 1.543 0 1 1 1.545 1.544 1.543 1.543 0 0 1-1.545-1.544zm.151-9.267a1.4 1.4 0 1 1 2.778 0l-.54 5.413a.852.852 0 0 1-1.7 0z",
    transform: "translate(534.702 578.009)",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationActiveIcon);
export default __webpack_public_path__ + "static/media/exclamation-active-icon.adbe0a1e6e515c167ffd2c0e9fbdec1f.svg";
export { ForwardRef as ReactComponent };